export const errorTypes = {
    SUCCESS: "SUCCESS",
    FAIL: "FAIL",
    WARN: "WARN",
  };
  